// removed by extract-text-webpack-plugin
module.exports = {"tag":"msRpqBWI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tag/Tag.pcss
// module id = 748
// module chunks = 0